import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './Modules/Registration/Login';
import Dashboard from './Modules/Dashboard/Dashboard';
import RegistrationForm from './Modules/Registration/RegistrationForm';
import Home from './Modules/Home';
import ForgetPassword from './Modules/Auth/ForgetPassword';
import PaymentResult from './Modules/Components/Payment/PaymentResult';
import AdminLogin from './Admin/Auth/AdminLogin';
import AdminDashboard from './Admin/AdminDashboard';
import { AuthContext } from './Auth/AuthContext';
import ProtectedRoute from './Auth/ProtectedRoute';
import InactivityModal from './Auth/InactivityModal';
import VerifierDashboard from './Certificate/VerifierDashboard';
import VerifierLogin from './Certificate/Auth/VerifierLogin';
import VerifierRegistration from './Certificate/Auth/VerifierRegistration';
import VerifierForgetPassword from './Certificate/Auth/VerifierForgetPassword';
import AvgCalculator from './Modules/Components/AvgCalculator/AvgCalculator';
import Vacancy from './Modules/Components/VacancyPosition/Vacancy';
import { cvurl, serverUrl } from './Constant/Static/config';
import axios from 'axios';
import ScrollButton from './Modules/Components/ScrollButton';
import CollegeLogin from './Modules/Components/CollegewiseAlloted/Login/CollegeLogin';
import CollegeResetPassword from './Modules/Components/CollegewiseAlloted/Reset/Reset';
import CollegeDashboard from './Modules/Components/CollegewiseAlloted/CollgeDashboard/CollegeDashboard'

const App = () => {
  const { auth } = useContext(AuthContext);


  // const [isAllowed, setIsAllowed] = useState(false);
  // const [response, setResponse] = useState('')
  // useEffect(() => {
  //   const restrict = async () => {
  //     const response = await axios.post(`${serverUrl}/api/check-ip`)
  //     if (response.status === 200) {
  //       setIsAllowed(true)
  //       setResponse(response.data.ip);
  //     }
  //     else {
  //       setIsAllowed(false)
  //       setResponse(response.data.ip);
  //     }
  //   }
  //   restrict();
  // }, []);

  // if (!isAllowed) {
  //   return (
  //     null
  //   );
  // }


  return (
    <Router>
      <InactivityModal />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/avg-calculator" element={<AvgCalculator />} />
        <Route path="/college-login" element={<CollegeLogin />} />
        <Route path="/college-reset" element={<CollegeResetPassword />} />
        <Route path="/college-dashboard" element={<CollegeDashboard />} />
        {/* <Route path="/vacancy-position" element={<Vacancy/>} /> */}

        {/* User Authentication */}
        <Route path="/login" element={auth.isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute role="user">
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/register" element={<RegistrationForm />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />
        <Route path="/payment-response" element={<PaymentResult />} />

        {/* Admin Authentication */}
        <Route path="/admin/login" element={auth.isAdminAuthenticated ? <Navigate to="/admin/dashboard" /> : <AdminLogin />} />
        <Route
          path="/admin/dashboard/*"
          element={
            <ProtectedRoute role="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* Certificate Verifier Authentication */}
        <Route path="/cv/login" element={auth.isVerifierAuthenticated ? <Navigate to="/cv/verifier/dashboard" /> : <VerifierLogin />} />
        <Route
          path="/cv/verifier/dashboard/*"
          element={
            <ProtectedRoute role="verifier">
              <VerifierDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/cv/register" element={<VerifierRegistration />} />
        <Route path="/cv/forgot-password" element={<VerifierForgetPassword />} />
      </Routes>
      {/* <ScrollButton /> */}
    </Router>
  );
};

export default App;